import {defineStore} from 'pinia';
import {ref} from 'vue';
import ApiService from '@core/services/ApiService';

export interface MenuItem {
  name: string;
  page?: {
    file: string;
    filename: string;
    route: string;
  };
  menuItems: MenuItem[];
}

const findMenuItem = (
  items: MenuItem[],
  root: string,
  folder: string,
  route: string,
): MenuItem | undefined => {
  const rootItem = items.find(item => item.name === root);
  if (rootItem && folder) {
    const folderItem = rootItem.menuItems.find(item => item.name === folder);
    if (route) {
      return folderItem?.menuItems?.find(item => item.name === route);
    }
    return folderItem;
  }
  return rootItem;
};

export const useMenuStore = defineStore(
  'MenuStore',
  () => {
    const menuItems = ref<MenuItem[]>([]);
    const currentMenu = ref<number>(0);

    const api = ApiService.getApiInstance();

    const loadMenuItems = async () => {
      const response = await api.get('/menuitems');
      menuItems.value = response.data;
    };

    const searchDocumentation = async (enteredText: string) => {
      const response = await api.get(
        `/menuitems/search?enteredText=${encodeURIComponent(enteredText)}`,
      );
      return response.data;
    };

    const getCurrentPage = (
      root: string,
      folder: string,
      route: string,
    ): MenuItem | undefined => {
      return findMenuItem(menuItems.value, root, folder, route);
    };

    const setMenu = (id: number) => {
      currentMenu.value = id;
    };

    const $reset = () => {
      menuItems.value = [];
      currentMenu.value = 0;
    };

    return {
      menuItems,
      currentMenu,
      loadMenuItems,
      searchDocumentation,
      getCurrentPage,
      setMenu,
      $reset,
    };
  },
  {
    persist: {
      pick: ['currentMenu'],
    },
  },
);
